// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"b484d92b","977":"546a0253"}[chunkId] + ".chunk.js";
};